"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolutionToFormPayload = resolutionToFormPayload;
exports.readFloatsAndTies = readFloatsAndTies;
exports.readBoundariesByClass = readBoundariesByClass;
exports.readStepValuesFromResolution = readStepValuesFromResolution;
exports.buildPinsFromPinout = buildPinsFromPinout;
exports.applyFloatsAndTies = applyFloatsAndTies;
exports.buildParametersForResolution = buildParametersForResolution;
exports.applyPayloadToResolution = applyPayloadToResolution;
const CadstromObjectType_1 = require("../../CadstromUid/CadstromObjectType");
const CadstromUid_1 = require("../../CadstromUid/CadstromUid");
const resolution_projection_1 = require("../../Consensus/resolution-projection");
const resolution_view_1 = require("./resolution-view");
function resolutionToFormPayload(sigmaModelType, resolution) {
    return {
        sigmaModelType,
        signals: resolution.signals,
        parameters: (0, resolution_projection_1.readParameters)(resolution.sigmaModelParameters),
        pinout: (0, resolution_projection_1.readPinout)(resolution.pins),
        spiceModels: resolution.spiceModels,
        boundaries: resolution.boundaries,
    };
}
function readFloatsAndTies(signals) {
    return Object.fromEntries(signals.map((signal) => [signal.id, { floatingBehavior: signal.floatingBehavior, ties: signal.ties }]));
}
function readBoundariesByClass(boundaries, boundaryClass) {
    return boundaries.filter((b) => b.boundary.class === boundaryClass);
}
function readStepValuesFromResolution(view) {
    const signals = view.signals ?? [];
    const boundaries = view.boundaries ?? [];
    return {
        signals,
        pinout: (0, resolution_projection_1.readPinout)(view.pins ?? []),
        parameters: (0, resolution_projection_1.readParameters)(view.sigmaModelParameters ?? {}),
        floatsAndTies: readFloatsAndTies(signals),
        functions: view.functions ?? [],
        resources: view.resources ?? [],
        modes: view.modes ?? [],
        amrBoundaries: readBoundariesByClass(boundaries, resolution_view_1.BOUNDARY_CLASS_AMR),
        ocBoundaries: readBoundariesByClass(boundaries, resolution_view_1.BOUNDARY_CLASS_OC),
        spiceModels: view.spiceModels ?? [],
    };
}
function buildPinsFromPinout(pinout) {
    const pins = [];
    for (const [signalId, pinNames] of Object.entries(pinout)) {
        for (const pinName of pinNames) {
            pins.push({
                id: (0, CadstromUid_1.generateCadstromUid)(CadstromObjectType_1.CadstromObjectType.PackageStorePin),
                name: pinName,
                signalRef: signalId,
            });
        }
    }
    return pins;
}
function applyFloatsAndTies(signals, floatsAndTies) {
    const updated = [...signals];
    const indexById = new Map(updated.map((s, i) => [String(s.id), i]));
    for (const [signalId, floatTie] of Object.entries(floatsAndTies)) {
        const idx = indexById.get(signalId);
        if (idx !== undefined) {
            updated[idx] = { ...updated[idx], floatingBehavior: floatTie.floatingBehavior, ties: floatTie.ties };
        }
    }
    return updated;
}
function buildParametersForResolution(parameters) {
    const converted = {};
    for (const [key, valueVariance] of Object.entries(parameters)) {
        converted[key] = {
            value: valueVariance.value ?? undefined,
            variance: valueVariance.variance ?? undefined,
        };
    }
    return converted;
}
function applyPayloadToResolution(payload) {
    const pins = buildPinsFromPinout(payload.pinout);
    const signals = applyFloatsAndTies(payload.signals, payload.floatsAndTies);
    return {
        sigmaModelId: payload.sigmaModelType,
        pins,
        sigmaModelParameters: buildParametersForResolution(payload.parameters),
        modes: payload.modes,
        boundaries: payload.boundaries,
        resources: payload.resources,
        functions: payload.functions,
        signals,
        spiceModels: payload.spiceModels,
    };
}
//# sourceMappingURL=package-resolution-codecs.js.map